export const modeName = "select_feature";

/// when a (multi-)polygon feature is hovered to be selected, it gets highlighted.
/// here is the name of the property indicating the highlight.
export const highlightPropertyName = `${modeName}_highlight`;

export const defaultOptions = {
  highlightColor: "#222",
};
